import { Injectable, inject } from '@angular/core';
import { WINDOW } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly window = inject<Window>(WINDOW);

  private localStorage: Storage;

  constructor() {
    this.localStorage = this.window.localStorage;
  }

  set<T>(key: string, value: T): void {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  get<T>(key: string): T | null {
    if (this.localStorage.getItem(key) !== null) {
      return JSON.parse(this.localStorage.getItem(key)!);
    }
    return null;
  }

  has(key: string): boolean {
    return this.localStorage.getItem(key) !== null;
  }

  remove(key: string): void {
    this.localStorage.removeItem(key);
  }
}
